import React from 'react';
import './ServicesHeroSection.css';

function ServicesHeroSection() {
  return (
    <section className="services-hero">
      <div className="services-hero-content">
        {/* <h1>Our Services</h1>
        <p>Empowering businesses with cutting-edge IT solutions and expert consulting.</p> */}
      </div>
    </section>
  );
}

export default ServicesHeroSection;